<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="main-container" [dir]="direction">
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
<app-enterprise-lock-overlay></app-enterprise-lock-overlay>
